import React from 'react';

import ReplyIcon from '@mui/icons-material/Reply';

import BaseActionButton from '../BaseActionButton';
import { IBaseActionButtonProps } from '../interfaces';

const ReplyActionButton = (props: IBaseActionButtonProps) => {
  return (
    <BaseActionButton {...props}>
      <ReplyIcon />
    </BaseActionButton>
  );
};

export default ReplyActionButton;
